<template>
  <div class="faq lg:px-0">
    <div class="head relative">
      <img :src="$path + faqs.image?.data?.attributes?.url" alt="">
      <div class="title absolute text-white">{{ faqs.title }}</div>
      <div class="description absolute text-white top-5 left-2/4" v-html="faqs.description"></div>
      <div class="search absolute w-80">
        <el-input class=" rounded-full" placeholder="请输入搜索关键词" suffix-icon="el-icon-search" v-model="input">
        </el-input>
      </div>
    </div>
    <div class="faq-1">
      <div class="tabs text-center bg-white">
        <div class=" h-16 inline-flex flex-row items-center rounded-md text-center">
          <div class="text-xs  px-2 mx-2 font-medium lg:text-base cursor-pointer py-1 rounded-md"
            :class="active === 'registerAndOpenAccount' ? 'primary_color' : ''"
            @click="activeTab('registerAndOpenAccount')">
            {{ translations.faqCategory?.registerAndOpenAccount }}
          </div>
          <div class="text-xs  px-2 mx-2 font-medium lg:text-base cursor-pointer py-1 rounded-md"
            :class="active === 'depositAndWithdrawal' ? 'primary_color' : ''"
            @click="activeTab('depositAndWithdrawal')">
            {{ translations.faqCategory?.depositAndWithdrawal }}
          </div>
          <div class="text-xs  px-2 mx-2 font-medium lg:text-base cursor-pointer py-1 rounded-md"
            :class="active === 'relatedTransaction' ? 'primary_color' : ''" @click="activeTab('relatedTransaction')">
            {{ translations.faqCategory?.relatedTransaction }}
          </div>
          <div class="text-xs  px-2 mx-2 font-medium lg:text-base cursor-pointer py-1 rounded-md"
            :class="active === 'transactionTerminal' ? 'primary_color' : ''" @click="activeTab('transactionTerminal')">
            {{ translations.faqCategory?.transactionTerminal }}
          </div>
          <div class="text-xs  px-2 mx-2 font-medium lg:text-base cursor-pointer py-1 rounded-md"
            :class="active === 'knowledge' ? 'primary_color' : ''" @click="activeTab('knowledge')">
            {{ translations.faqCategory?.knowledge }}
          </div>
        </div>
      </div>
      <div class="container mx-auto py-6 items-center">
        <el-collapse v-model="activeNames">
          <el-collapse-item :title="item.title" name="1" v-for="item in faqs.faqs" :key="item.id">
            <div v-html="item.description"></div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue'
import $ from 'jquery'
import { mapGetters } from 'vuex'
import { getFaqs, getTranslations } from '@/api/index'
export default {
  name: 'Home',
  data() {
    return {
      active: 'registerAndOpenAccount',
      oneActiveAry: ['1', '2'],
      xsShow: false, // 手机显示
      activeWidth: window.innerWidth,
      faqs: {},
      activeNames: ['1'],
      translations: {},
      input: ''
    }
  },
  watch: {
    activeWidth: {
      handler(val, oldVal) {
        if (val <= 416) {
          this.xsShow = true
        } else {
          this.xsShow = false
        }
      },
      deep: true, // true 深度监听
      immediate: true
    },
    input(e) {
      this.getFaqs(this.active, e)
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo',
      lang: 'getLang'
    }),
    lang() {
      return this.$store.state.lang
    }
  },
  components: {},
  created() {
    this.getTranslations()
    this.getFaqs()
  },
  mounted() {
    const vm = this
    setTimeout(_ => {
      const position = vm.$route.query.position
      if (position === 'disclosureStatement') {
        vm.oneActiveAry.push('5')
        console.log($('.faq-2').offset().top)
        $('html,body').animate({
          scrollTop: $('.faq-2').offset().top + 200
        }, 500)
      }
    }, 200)
  },
  methods: {
    activeTab(tab) {
      this.active = tab
      this.getFaqs(tab)
    },
    goOpenTradingAccount() {
      this.$emit('goOpenTradingAccount')
    },
    async getFaqs(name, title = '') {
      const params = {
        'populate[image][fields]': 'url',
        'populate[faqs][fields]': '*',
        'populate[faqs][filters][title][$contains]': title,
        'populate[faqs][filters][category][$eq]': name || this.active
      }
      const result = await getFaqs(params)
      this.faqs = result.data.attributes
    },
    async getTranslations() {
      const result = await getTranslations()
      this.translations = result.data.attributes.translations
    }
  }
}
</script>

<style lang="less" scoped>
.faq {
  background: #F9FAFB;

  .faq-1 {
    background-color: #fff;
    margin-bottom: 30px;

    // .choice-tabs {
    //   background: linear-gradient(0deg, #EAECF0, #EAECF0),
    //     linear-gradient(0deg, #F9FAFB, #F9FAFB);
    // }
    .tabs {
      height: 4rem;
      box-shadow: 0px 0px 1rem 0px rgba(0, 0, 0, 0.05);
      color: #71717A;
    }
  }

  .title,
  .description,
  .search {
    top: 2rem;
    left: 50%;
    transform: translate(-50%);
  }

  .title {
    font-size: 1.8rem;
  }

  .search {
    top: 12rem;
  }

  .description {
    top: 5rem;
    padding-top: 1rem;
  }

  /deep/ .el-input__inner {
    border-radius: 2rem;
    height: 2.5rem;

    &:focus {
      border-color: #AF6BC2;
    }
  }

  /deep/ .el-collapse {
    border-top: none;
    border-bottom: none;

    .el-collapse-item {
      .el-collapse-item__header {
        border-bottom: none;
        background: #F9FAFB;
        margin-top: 0.8rem;
        border-radius: 4px;
        color: #182445;
      }

      .el-collapse-item__wrap {
        background: #F9FAFB;
      }

      .el-collapse-item__wrap {
        border-bottom: none;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .faq {
    .title {
      font-size: 1.3rem;
      top: 0.8rem;
    }

    .description {
      top: 1.8rem;
      font-size: 12px;
    }

    .search {
      top: 10rem;
    }

    .tabs {
      overflow-y: hidden;
    }

    .container {
      margin-top: 4rem;
      padding: 10px 0.5rem;
    }

    /deep/ .el-collapse {
      border-top: none;
      border-bottom: none;

      .el-collapse-item {
        .el-collapse-item__header {
          height: 2.5rem
        }
      }
    }
  }
}
</style>
